import { createUseStyles } from "react-jss";
import { BADGE_SIZES_JSS } from "../../../constants/badge";

export const useStyles = createUseStyles({
  root: {
    ...BADGE_SIZES_JSS,
  },
});
